import * as types from 'store/types';
import { update } from 'variables/utilities';

const initial = {
  preferences: null, request: null,
	loading: false
};

const started = (state, action) => {
	return update( state, {
		request: action.request,
		error: null, loading: true
	});
};

const succeeded = (state, action) => {
	return update( state, {
		preferences: action.preferences ? action.preferences : state.preferences,
		loading: false, modified: new Date(),
	});
};

const failed = (state, action) => {
	return update( state, {
			error: action.error, loading: false
	});
}

const personalization = (state = initial, action) => {
	switch ( action.type ) {
		case types.PERSONALIZATION_START: 
			return started(state, action);

		case types.PERSONALIZATION_SUCCESS: 
			return succeeded(state, action);

		case types.PERSONALIZATION_FAILURE: 
			return failed(state, action);

		default:
			return state;
	}
};

export default personalization;